module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_vote_gray.d268d.png";